module.exports = __webpack_public_path__ + "images/new_capture/capture-illustration-e03fd429cfe560f89343b18184d0b98e.png";